import { useSearchParams, useNavigate, Link } from "react-router-dom";
import SiteHeader from "@/components/SiteHeader";
import SiteFooter from "@/components/SiteFooter";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const ref = params.get("ref");

  return (
    <div className="min-h-screen bg-[#f8f9fa]" data-testid="payment-cancel-page">
      <SiteHeader />
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-24">
        <div className="bg-white rounded-3xl p-8 md:p-12 border border-gray-100 mbk-card-shadow text-center">
          <div className="h-16 w-16 rounded-full bg-amber-100 text-amber-600 flex items-center justify-center mx-auto"><XCircle className="h-8 w-8" /></div>
          <h1 className="font-display text-3xl font-black text-[#0a1e3f] mt-6" data-testid="payment-cancel-title">Paiement annulé</h1>
          <p className="text-sm text-gray-600 mt-2 max-w-md mx-auto">
            Vous avez annulé le paiement{ref ? <> pour la réservation <b>{ref}</b></> : null}. Aucun montant n'a été prélevé.
            Votre réservation reste enregistrée mais non confirmée — le véhicule reste donc disponible pour d'autres clients.
          </p>
          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
            <Button data-testid="cancel-back-mybookings" onClick={() => navigate("/my-bookings")} className="mbk-btn-primary text-white h-11 px-6 rounded-full">
              Reprendre le paiement
            </Button>
            <Link to="/" className="text-sm font-semibold text-[#0e7a3f] hover:underline">Retour à l'accueil</Link>
          </div>
        </div>
      </div>
      <SiteFooter />
    </div>
  );
}
